<template>
  <main>
    <Header :loginSource="1"></Header>
    <section class="logo_search_container">
      <div class="banner">
        <div class="banner-box">
          <div class="title-1">大模型服务与开发平台</div>
          <div class="title-2">大模型企业级服务入口，提供高可用及高性价比的生成式AI服务及全流程模型开发工具链</div>
          <div class="banner-btn-box">
            <div class="banner-btn-1" @click="gotoConsole()">控制台</div>
<!--            <div class="banner-btn-1" @click="gotoProduct()">立即购买</div>-->
<!--            <div class="banner-btn-2">企业咨询</div>-->
          </div>
        </div>
      </div>
    </section>

    <section class="desc-box">
      <div class="desc-title">产品优势</div>
      <div class="desc-content">高性能易调用，高开放易集成，高可用易落地，超低价安全可信，助力企业打造最优落地效果的大模型应用</div>
    </section>

    <section class="desc-box2">
      <div>
        <img class="desc-box2-image" src="/static/images/cpys/cpys-1.png">
      </div>
      <div class="desc-box2-content">
        <div class="desc-box2-content-1">丰富多样的模型服务，业务落地选择更多</div>
        <div class="desc-box2-content-2">大模型能力即开即用，提供优质开源和闭源，文本、语音、图片等多种模态大模型供选择，支持高性能的模型调用服务，以及开放的大模型三方生态合作。</div>
      </div>
    </section>

    <section class="desc-box2" style="background-color: rgba(243, 243, 243, 0.5);">
      <div>
        <img class="desc-box2-image" src="/static/images/cpys/cpys-2.png">
      </div>
      <div class="desc-box2-content">
        <div class="desc-box2-content-1">应用构建开放高效，业务落地更轻松</div>
        <div class="desc-box2-content-2">兼容LlamaIndex等开源框架和Open AI的Assistant API调用，支持5-10分钟低代码快速构建智能体。应用和模型双引擎驱动发展生态化共建，助力千行百业落地大模型应用。</div>
      </div>
    </section>

    <section class="desc-box2">
      <div>
        <img class="desc-box2-image" src="/static/images/cpys/cpys-3.png">
      </div>
      <div class="desc-box2-content">
        <div class="desc-box2-content-1">离线调用推理，成本直降50%，业务落地更划算</div>
        <div class="desc-box2-content-2">提供实时/Batch调用多种服务计费模式，支持在线部署模型按需扩缩容，包月或先用后付结算都能满足。新用户千万token免费送，为大模型创新落地提供极致性价比。</div>
      </div>
    </section>

    <section class="desc-box2" style="background-color: rgba(243, 243, 243, 0.5);">
      <div>
        <img class="desc-box2-image" src="/static/images/cpys/cpys-4.png">
      </div>
      <div class="desc-box2-content">
        <div class="desc-box2-content-1">丰富多样的模型服务，业务落地选择更多</div>
        <div class="desc-box2-content-2">大模型能力即开即用，提供优质开源和闭源，文本、语音、图片等多种模态大模型供选择，支持高性能的模型调用服务，以及开放的大模型三方生态合作。</div>
      </div>
    </section>

    <div style="margin-bottom: 15px;"></div>
    <Footer></Footer>
  </main>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'Index',
  components: {Header, Footer},
  comments: {
    Header
  },

  data() {
    return {
      interval: 10000
    }
  },

  methods: {
    async getCourses () {
      if (this.courses.length)
        return

      const result = await reqFindAllCourse()
      if (result.code === 0) {
        const courses = result.data
        this.$store.dispatch('setCourses', {courses})
      }
    },

    gotoConsole () {
      this.$router.push({
        path: '/customerCenter'
      })
    },

    gotoProduct () {
      this.$router.push({
        path: '/respkg'
      })
    },

  },

}
</script>

<style scoped>

  main {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .logo_search_container {
    display: flex;
    width: 100%;
    margin: 0px auto;
  }

  .banner {
    width: 100%;
    height: 500px;
    margin: 0 auto;
    background-image: url("/static/images/banner_ai.png");

  }

  .banner-box {
    display: flex;
    flex-direction: column;
    width: 720px;
    height: 100%;
    padding-left: 80px;
  }

  .title-1 {
    margin-top: 150px;
    color: black;
    font-size: 48px;
    font-weight: 460;
    letter-spacing: 3px;
    line-height: 60px;
  }

  .title-2 {
    width: 500px;
    margin-top: 20px;
    font-size: 18px;
    font-weight: 320;
    color: #333;
    line-height: 28px;
  }

  .banner-btn-box {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
  }

  .banner-btn-1 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 190px;
    height: 48px;
    background: linear-gradient(to right, #4033E8 0%, #5F57DA 100%);
    color: #fff;
    cursor: pointer;
    border: solid 1px blue;
  }

  .banner-btn-1:hover {
    background: linear-gradient(to right, #2015C1 0%, #5F57DA 100%);
  }

  .banner-btn-2 {
    margin-left: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 190px;
    height: 48px;
    color: #0091FF;
    cursor: pointer;
    border: solid 1px #666;
  }

  .banner-btn-2:hover {
    background: linear-gradient(to right, #C9D6E3 0%, #EAEDF1 100%);
  }

  .desc-box {
    display: flex;
    flex-direction: column;
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .desc-title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 32px;
    font-weight: 460;
    letter-spacing: 2px;
    line-height: 60px;
  }

  .desc-content {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    letter-spacing: 1px;
    line-height: 60px;
    font-weight: 300;
  }

  .desc-box2 {
    display: flex;
    flex-direction: row;
    padding-left: 25px;
    padding-right: 80px;
    margin-top: 15px;
    margin-bottom: 10px;
  }

  .desc-box2-image {
    width: 696px;
    height: 400px;
    /*border-radius: 6px;*/
    /*margin-right: 20px;*/
    /*cursor: pointer;*/
    /*border: 1px solid;*/
  }

  .desc-box2-content {
    display: flex;
    flex-direction: column;
    padding-left: 40px;
    padding-top: 50px;
  }

  .desc-box2-content-1 {
    font-size: 26px;
    font-weight: 460;
    letter-spacing: 1px;
    line-height: 60px;
  }
  .desc-box2-content-2 {
    font-size: 16px;
    letter-spacing: 1px;
    line-height: 30px;
    font-weight: 300;
  }

  .box {
    width: 100%;
    height: 500px;
    margin: 0 auto;
    background: rgb(255,255,255);

  }
  .bg{
    width:100%; height:400px;
    background: linear-gradient(90deg, #33ccff 0%, #E9E7FB 51%, #DCEBFA 100%);
    mask-image: linear-gradient(to top, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
  }

</style>



// WEBPACK FOOTER //
// src/pages/Index/Index.vue